(function () {
  document.querySelectorAll('[data-prv-hero]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.prv-hero-slide'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('.prv-hero-dot'));
    var prevBtn = slider.querySelector('.prv-hero-nav-prev');
    var nextBtn = slider.querySelector('.prv-hero-nav-next');
    if (slides.length < 2) return;

    var current = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = slider.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 6000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAutoplay() {
      if (reducedMotion || !autoplayEnabled) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);
    startAutoplay();
  });
})();
